if (!customElements.get('pcard-vip-blocking')) {
  customElements.define('pcard-vip-blocking', class PCardVipBlocking extends HTMLDivElement {
    connectedCallback() {
      if (this.isProductLocked()) {
        this.applyBlocking();
      }
    }

    isProductLocked() {
      if (!window.Samita || !window.Samita.SamitaLocksAccessParams || !window.Samita.SamitaLocksAccessParams.locks) {
        return false;
      }

      const productId = this.dataset.productId;

      for (const lock of window.Samita.SamitaLocksAccessParams.locks) {
        const rl = lock.resources_lock;
        if (rl && rl.limitProduct === 'manual' && rl.products[productId]) {
          return true;
        }
      }

      return false;
    }

    applyBlocking() {
      const imageLink = this.querySelector('.product-card__image-link');
      if (imageLink) {
        imageLink.classList.add('blur-sm');
      }

      const vipBadge = this.querySelector('.f-badge--vip');
      if (vipBadge) {
        vipBadge.classList.remove('hidden');
      }

      this.querySelectorAll('.f-badge:not(.f-badge--vip)').forEach(badge => {
        badge.classList.add('hidden');
      });

      const iconContainers = this.querySelectorAll('.product-card__atc-icon');
      iconContainers.forEach(container => {
        const defaultIcon = container.querySelector('.icon:not(.icon-lock)');
        const lockIcon = container.querySelector('.icon.icon-lock');
        if (defaultIcon) defaultIcon.classList.add('hidden');
        if (lockIcon) lockIcon.classList.remove('hidden');
      });

      this.setGoToProductPage();
    }

    setGoToProductPage() {
      const toPdpContainer = this.querySelector('.product-card__main-actions.to-pdp');
      const addToCartForm = this.querySelector('.product-card__main-actions[data-type="add-to-cart-form"]');
      if (toPdpContainer) {
        toPdpContainer.classList.remove('!hidden');
      }
      if (addToCartForm) {
        addToCartForm.style.display = 'none';
      }
    }
  }, {extends: 'div'});
}
